import { useNavigate } from 'react-router-dom'
import PATHS from '@/routes/paths'
import { useWorkspaceStore } from '@/store/workspaceStore'
import { invalidateWorkspaceScopedQueries } from '@/services/workspaces/workspaceQueryKeys.js'

export function useWorkspaceSwitcher() {
  const navigate = useNavigate()
  const setActiveWorkspaceId = useWorkspaceStore((s) => s.setActiveWorkspaceId)
  return (workspaceId) => {
    if (!workspaceId) return
    setActiveWorkspaceId(workspaceId)
    invalidateWorkspaceScopedQueries(workspaceId)
    navigate(PATHS.HOME, { replace: true })
  }
}
